var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useMediaQuery } from "@mui/material";
import { LOCAL_STORAGE_KEYS } from "../../../constants";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { ExpandLess, ExpandMore, MoreVert } from "@mui/icons-material";
import dayjs from "dayjs";
import { ReactComponent as PrintIcon } from '../../../assets/images/printIcon.svg';
import { ReactComponent as ShearIcon } from '../../../assets/images/shearIcon.svg';
import { ReactComponent as ViewIcon } from '../../../assets/images/viewIcon.svg';
import ActionMenuList from "../../../builderPackage/components/actionsMenuList";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import InfiniteScroll from "../../../builderPackage/components/infiniteScroll/infiniteScroll";
import { showSurface } from "../../../redux/awaitedSurfacesSlice";
import { getLocalStorageItem } from "../../../utils/storageHelper";
import { dateFormate } from "../../../utils/utils";
import { ContractSaleInvoicePagingAPI } from "../services/apiCall";
import { ContractInvoiceKeys } from "../services/entity";
export var ContractSaleInvoiceCatalogueInvoicedMobileView = function (props) {
    var _getLocalStorageItem, _getLocalStorageItem2, _crud$ContractInvoice, _crud$ContractInvoice2;
    var value = props.value;
    var userOrganizationID = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.Branches[0]) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.OrganizationId;
    var parentOrganizationId = (_getLocalStorageItem2 = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.data) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.Branches[0]) === null || _getLocalStorageItem2 === void 0 ? void 0 : _getLocalStorageItem2.ParentOrganizationId;
    var upXS = useMediaQuery(function (theme) { return theme.breakpoints.up("xs"); });
    var downSM = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var storedMenuFeatures = getLocalStorageItem(LOCAL_STORAGE_KEYS.MENU_FEATURE);
    console.log("storedMenuFeatures", storedMenuFeatures);
    var allowedFeatures = new Set(["ViewInvoice", "ShareInvoice", "PrintInvoice"]);
    var IS_MOBILE = upXS && downSM;
    var crud = useAppSelector(function (state) { return state.crud; });
    var appDispatch = useAppDispatch();
    var hasMore = !crud[ContractInvoiceKeys.Paging] || ((_crud$ContractInvoice = crud[ContractInvoiceKeys.Paging]) === null || _crud$ContractInvoice === void 0 || (_crud$ContractInvoice = _crud$ContractInvoice.data) === null || _crud$ContractInvoice === void 0 ? void 0 : _crud$ContractInvoice.length) < ((_crud$ContractInvoice2 = crud[ContractInvoiceKeys.Paging]) === null || _crud$ContractInvoice2 === void 0 ? void 0 : _crud$ContractInvoice2.TotalCount);
    var getIcon = function (name) {
        switch (name) {
            case 'ViewInvoice':
                return /*#__PURE__*/ React.createElement(ViewIcon, {
                    height: 16,
                    width: 16
                });
            case 'ShareInvoice':
                return /*#__PURE__*/ React.createElement(ShearIcon, {
                    height: 16,
                    width: 16
                });
            case 'PrintInvoice':
                return /*#__PURE__*/ React.createElement(PrintIcon, {
                    height: 16,
                    width: 16
                });
            default:
                return /*#__PURE__*/ React.createElement(React.Fragment, null);
        }
    };
    var formData = [{
            type: FormItemTypes.CardComponent,
            name: '',
            columnSize: 12,
            onClick: function () { },
            contentProps: {
                spacing: 0.5
            },
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    justifyContent: "space-between",
                    display: "flex",
                    alignItems: 'center',
                    spacing: 0,
                    elements: [{
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 8,
                            justifyContent: 'center',
                            alignItems: 'flex-start',
                            flexDirection: 'column',
                            spacing: 0,
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: "OrderNumber",
                                    columnSize: true,
                                    labelTypographyProps: {
                                        fontSize: 'base',
                                        fontWeight: 'medium'
                                    },
                                    fontSize: 'base',
                                    fontWeight: 'medium'
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: "OrderDate",
                                    valueGetter: function (val, row) { return val !== null && val !== void 0 && val.OrderDate ? "".concat(dateFormate(val === null || val === void 0 ? void 0 : val.OrderDate)) : '-'; },
                                    // label: cardData.docNo,
                                    columnSize: true,
                                    labelTypographyProps: {
                                        fontSize: 'base',
                                        fontWeight: 'medium',
                                        color: 'secondary.900'
                                    },
                                    fontSize: 'sm',
                                    fontWeight: 'normal',
                                    color: 'secondary.500'
                                }]
                        }, {
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 4,
                            justifyContent: 'flex-end',
                            alignItems: 'baseline',
                            spacing: 1,
                            elements: [{
                                    type: FormItemTypes.Chip,
                                    name: 'StatusName',
                                    variant: 'outlined',
                                    size: 'small',
                                    columnSize: 0,
                                    color: 'success',
                                    sx: {
                                        borderRadius: '6px'
                                    }
                                }, {
                                    type: FormItemTypes.IconButton,
                                    name: "menuIcon",
                                    color: 'secondary',
                                    size: 'small',
                                    children: /*#__PURE__*/ React.createElement(MoreVert, {
                                        color: "secondary"
                                    }),
                                    columnSize: 2,
                                    sx: {
                                        width: '18px',
                                        height: '18px'
                                    },
                                    setFormState: function (state, e) { return __awaiter(void 0, void 0, void 0, function () {
                                        var action;
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0: return [4 /*yield*/, appDispatch(showSurface({
                                                        type: 'Menu',
                                                        containerProps: {
                                                            anchorEl: e.target.parentElement
                                                        },
                                                        Component: ActionMenuList,
                                                        componentProps: {
                                                            items: __spreadArray([], (storedMenuFeatures === null || storedMenuFeatures === void 0 ? void 0 : storedMenuFeatures.filter(function (_ref) {
                                                                var Name = _ref.Name;
                                                                return allowedFeatures.has(Name);
                                                            }).map(function (item) {
                                                                console.log('ITEM', item);
                                                                return {
                                                                    id: item === null || item === void 0 ? void 0 : item.Name,
                                                                    children: [getIcon(item === null || item === void 0 ? void 0 : item.Name), item === null || item === void 0 ? void 0 : item.DisplayName]
                                                                };
                                                            })), true)
                                                        }
                                                    }))];
                                                case 1:
                                                    action = _a.sent();
                                                    return [2 /*return*/];
                                            }
                                        });
                                    }); }
                                }]
                        }]
                }, {
                    type: FormItemTypes.Accordian,
                    name: 'expanded',
                    value: false,
                    containerProps: {
                        spacing: 0
                    },
                    summaryProps: {
                        sx: {
                            display: 'none'
                        }
                    },
                    summary: [],
                    detailPanelProps: {
                        spacing: 1,
                        p: 1.5,
                        rowSpacing: 0
                    },
                    sx: {
                        bgcolor: 'background.secondary',
                        border: 'none'
                    },
                    columnSize: 12,
                    setFieldProps: function (state, currValue, field) {
                        // console.log('staet>>>>>', state)
                        return {
                            type: this.type,
                            containerProps: {
                                my: currValue ? 1.5 : 0
                            },
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: 'InvoiceNumber',
                                    label: 'Invoice number: ',
                                    fontSize: 'sm',
                                    fontWeight: 'medium',
                                    columnSize: 12,
                                    valueGetter: function (formValues, field) {
                                        var currValue = formValues === null || formValues === void 0 ? void 0 : formValues[this.name];
                                        if (currValue)
                                            return currValue;
                                        else
                                            return '-';
                                    },
                                    labelTypographyProps: {
                                        mb: 0
                                    },
                                    containerProps: {
                                        display: 'flex',
                                        direction: 'row',
                                        justifyContent: 'space-between'
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'InvoiceDate',
                                    label: 'Invoice date: ',
                                    fontSize: 'sm',
                                    fontWeight: 'medium',
                                    columnSize: 12,
                                    labelTypographyProps: {
                                        mb: 0
                                    },
                                    containerProps: {
                                        display: 'flex',
                                        direction: 'row',
                                        justifyContent: 'space-between'
                                    },
                                    valueGetter: function (formValues, field) {
                                        var currValue = formValues === null || formValues === void 0 ? void 0 : formValues[this.name];
                                        if (currValue)
                                            return dayjs(currValue).format('DD MMM YYYY - h:mm A');
                                        else
                                            return '-';
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'CustomerName',
                                    label: 'Customer name: ',
                                    fontSize: 'sm',
                                    fontWeight: 'medium',
                                    columnSize: 12,
                                    labelTypographyProps: {
                                        mb: 0
                                    },
                                    containerProps: {
                                        display: 'flex',
                                        direction: 'row',
                                        justifyContent: 'space-between'
                                    },
                                    valueGetter: function (formValues, field) {
                                        console.log("formValuesPPPPPPPPPP", formValues);
                                        var currValue = formValues === null || formValues === void 0 ? void 0 : formValues[this.name];
                                        if (currValue)
                                            return currValue;
                                        else
                                            return '-';
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'CustomerNumber',
                                    label: 'Customer number: ',
                                    fontSize: 'sm',
                                    fontWeight: 'medium',
                                    columnSize: 12,
                                    labelTypographyProps: {
                                        mb: 0
                                    },
                                    containerProps: {
                                        display: 'flex',
                                        direction: 'row',
                                        justifyContent: 'space-between'
                                    },
                                    valueGetter: function (formValues, field) {
                                        var currValue = formValues === null || formValues === void 0 ? void 0 : formValues[this.name];
                                        if (currValue)
                                            return currValue;
                                        else
                                            return '-';
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'InvoiceAmount',
                                    label: 'Invoice amount: ',
                                    fontSize: 'sm',
                                    fontWeight: 'medium',
                                    columnSize: 12,
                                    labelTypographyProps: {
                                        mb: 0
                                    },
                                    containerProps: {
                                        display: 'flex',
                                        direction: 'row',
                                        justifyContent: 'space-between'
                                    },
                                    valueGetter: function (formValues, field) {
                                        var currValue = formValues === null || formValues === void 0 ? void 0 : formValues[this.name];
                                        if (currValue)
                                            return currValue;
                                        else
                                            return '-';
                                    }
                                }]
                        };
                    },
                    elements: []
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    spacing: 0,
                    justifyContent: 'end',
                    elements: [{
                            type: FormItemTypes.Button,
                            name: 'expand-button',
                            columnSize: 0,
                            color: 'secondary',
                            size: 'small',
                            sx: {
                                p: 0,
                                fontSize: 'sm'
                            },
                            setFormState: function (formValues) {
                                return {
                                    expanded: !(formValues !== null && formValues !== void 0 && formValues.expanded)
                                };
                            },
                            setFieldProps: function (formValues) {
                                return {
                                    type: this.type,
                                    children: formValues !== null && formValues !== void 0 && formValues.expanded ? ['Close', /*#__PURE__*/ React.createElement(ExpandLess, null)] : ['View more', /*#__PURE__*/ React.createElement(ExpandMore, null)]
                                };
                            }
                        }]
                }]
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(InfiniteScroll, {
        apiCall: ContractSaleInvoicePagingAPI,
        apiKey: ContractInvoiceKeys.Paging,
        apiRequest: {
            Status: ['Invoiced'],
            OrganizationId: userOrganizationID,
            ParentOrganizationId: parentOrganizationId,
            IdentityId: (value === null || value === void 0 ? void 0 : value.IdentityId) !== "all" ? value === null || value === void 0 ? void 0 : value.IdentityId : null
        },
        elements: formData,
        hasMore: hasMore,
        gridContainerProps: {
            spacing: 2,
            p: 2
        },
        gridItemProps: {
            xs: 12
        }
    }));
};
